import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface RatingNudgeState {
  /** "Don't show again" — permanently hides the banner in every group. */
  hiddenForever: boolean
  /** groupId -> epoch ms watermark; games finished at/before this are dismissed. */
  dismissedThrough: Record<string, number>
  /** groupId -> gameIds the user explicitly un-rated; never nudge about these. */
  suppressedGames: Record<string, string[]>
  dismiss: (groupId: string, throughMs: number) => void
  suppressGame: (groupId: string, gameId: string) => void
  hideForever: () => void
}

export const useRatingNudgeStore = create<RatingNudgeState>()(
  persist(
    (set) => ({
      hiddenForever: false,
      dismissedThrough: {},
      suppressedGames: {},
      dismiss: (groupId, throughMs) =>
        set((s) => ({
          dismissedThrough: {
            ...s.dismissedThrough,
            // Never lower an existing watermark — only push it forward.
            [groupId]: Math.max(s.dismissedThrough[groupId] ?? -1, throughMs),
          },
        })),
      suppressGame: (groupId, gameId) =>
        set((s) => {
          const existing = s.suppressedGames[groupId] ?? []
          if (existing.includes(gameId)) return s
          return {
            suppressedGames: { ...s.suppressedGames, [groupId]: [...existing, gameId] },
          }
        }),
      hideForever: () => set({ hiddenForever: true }),
    }),
    { name: 'cg-rating-nudge' },
  ),
)
